// product grid/list
// function listgridJavascript() {
// Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
//     link.addEventListener('click', function(event) {
//         Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
//         this.classList.add('active');
//         if(this.classList.contains('listv')){
//             document.getElementById('product-grid').classList.add('product-list');
//             document.getElementById('product-grid').classList.remove('product-grid');
//             document.getElementById('product-grid').classList.remove('product-gallery');
//             // Remove 'active' class from gridv on mobile
//               if (window.innerWidth < 992) { 
//                 document.querySelector(".gridv").classList.remove('active_mobile'); 
//               }  
//         }else if(this.classList.contains('gridv')){
//             document.getElementById('product-grid').classList.add('product-grid');
//             document.getElementById('product-grid').classList.remove('product-list');
//             document.getElementById('product-grid').classList.remove('product-gallery');
//         }else if(this.classList.contains('galleryv')){
//             document.getElementById('product-grid').classList.add('product-gallery');
//             document.getElementById('product-grid').classList.remove('product-list');
//             document.getElementById('product-grid').classList.remove('product-grid');
//         }
//     });
// });
// };
// document.addEventListener("shopify:section:load", listgridJavascript);
// listgridJavascript();

function layoutSwitcher() {
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
    link.addEventListener('click', toggle);
    link.addEventListener('keydown', handleKeyDown);
  });
};
function handleKeyDown(event){
  if (event.keyCode === 13) {
    toggle(event);
  }
}
function toggle(event){
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
  event.currentTarget.classList.add('active');
  if(event.currentTarget.classList.contains('listv')){
    document.getElementById('ProductGridContainer').classList.add('product-list');
    document.getElementById('ProductGridContainer').classList.remove('product-grid');
    document.getElementById('ProductGridContainer').classList.remove('product-gallery');
    // Remove 'active' class from gridv on mobile
    if (window.innerWidth < 992) { 
       document.querySelector(".gridv").classList.remove('active_mobile'); 
    }
  }else if(event.currentTarget.classList.contains('gridv')){
    document.getElementById('ProductGridContainer').classList.add('product-grid');
    document.getElementById('ProductGridContainer').classList.remove('product-list');
    document.getElementById('product-grid').classList.remove('product-list');
    document.getElementById('ProductGridContainer').classList.remove('product-gallery');
  }else if(this.classList.contains('galleryv')){
      document.getElementById('ProductGridContainer').classList.add('product-gallery');
      document.getElementById('ProductGridContainer').classList.remove('product-list');
      document.getElementById('product-grid').classList.remove('product-list');
      document.getElementById('ProductGridContainer').classList.remove('product-grid');
  }
}
document.addEventListener("shopify:section:load", layoutSwitcher);
layoutSwitcher();


// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}

// timer
setInterval(countDown, 1000);
function countDown() {
  const countCardSections = document.querySelectorAll('.countd_all');
  countCardSections.forEach((countdownSection) => {
    var countDownDate = new Date(countdownSection.getAttribute('data-date').replaceAll('-','/')).getTime();
    var now = new Date().getTime();
    var distance = countDownDate - now;
    if (distance < 0 || isNaN(countDownDate)) {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = "00";
      countdownSection.querySelector('.main_chours .wb_chours').textContent = "00";
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = "00";
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = "00";
    }
    else {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
      countdownSection.querySelector('.main_chours .wb_chours').textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = Math.floor((distance % (1000 * 60)) / 1000);
    }
  });
}

/*
  GOCOX conversion fixes, 2026-07-27.
  Namespaced and idempotent so Shopify section reloads do not duplicate UI.
*/
(function () {
  var discountCode = 'GOCOX10';
  var discountCheckoutUrl = '/discount/' + discountCode + '?redirect=/checkout';

  function insertPatentProof() {
    var trustList = document.querySelector('.page-product .icon-with-text');

    if (!trustList || document.querySelector('[data-gcx-patent-proof]')) return;

    var link = document.createElement('a');
    link.className = 'gcx-patent-proof';
    link.dataset.gcxPatentProof = '';
    link.href = '/pages/golf-travel-case-design-patent';
    link.textContent = 'View U.S. design patent details';
    trustList.insertAdjacentElement('afterend', link);
  }

  function designInStockShippingNote() {
    var stockBlock = document.querySelector('.page-product .wbstockcount');
    var stockInfo = stockBlock
      ? stockBlock.querySelector('.wbstockinfo')
      : null;

    if (!stockBlock || !stockInfo) return;
    if (/pre-?order/i.test(stockInfo.textContent)) return;
    if (stockInfo.hasAttribute('data-gcx-shipping-note')) return;

    stockBlock.classList.add('gcx-shipping-card');
    stockInfo.classList.remove('wbstockinfo_low');
    stockInfo.setAttribute('data-gcx-shipping-note', '');
    stockInfo.innerHTML =
      '<div class="gcx-shipping-card__row gcx-shipping-card__row--preorder">' +
        '<span class="gcx-shipping-card__status gcx-shipping-card__status--preorder" aria-hidden="true"></span>' +
        '<p class="gcx-shipping-card__copy">' +
          '<strong>Pre-order items:</strong> estimated delivery in about 4 weeks.' +
        '</p>' +
      '</div>' +
      '<div class="gcx-shipping-card__row gcx-shipping-card__row--instock">' +
        '<span class="gcx-shipping-card__status" aria-hidden="true"></span>' +
        '<p class="gcx-shipping-card__copy">' +
          '<strong>In-stock items:</strong> orders usually ship within 1-2 business days.' +
          '<span>Delivery typically takes 2-5 business days after shipment.</span>' +
        '</p>' +
      '</div>';

    var progressBar = stockBlock.querySelector('.wbstockinfo-bar');

    if (progressBar) {
      progressBar.hidden = true;
    }
  }

  function syncCartDrawerOverlayState() {
    var cartDrawer = document.querySelector('cart-drawer');
    var isOpen = Boolean(
      cartDrawer && cartDrawer.classList.contains('active')
    );

    document.body.classList.toggle('gcx-cart-drawer-open', isOpen);
  }

  function buildCartDiscount() {
    var wrapper = document.createElement('div');
    wrapper.className = 'gcx-cart-discount';
    wrapper.dataset.gcxCartDiscount = '';
    wrapper.innerHTML =
      '<div class="gcx-cart-discount__copy">' +
        '<strong>Eligible first order? Save 10%</strong>' +
        '<span>Apply code ' + discountCode + ' before payment.</span>' +
      '</div>' +
      '<a class="gcx-cart-discount__action" rel="nofollow" href="' +
        discountCheckoutUrl +
      '">Apply ' + discountCode + '</a>';
    return wrapper;
  }

  function insertCartDiscounts() {
    var cartBlocks = document.querySelector('#main-cart-footer .cart__blocks');

    if (cartBlocks && !cartBlocks.querySelector('[data-gcx-cart-discount]')) {
      cartBlocks.insertBefore(buildCartDiscount(), cartBlocks.firstChild);
    }

    var drawerFooter = document.querySelector('cart-drawer .drawer__footer');
    var drawerCtas = drawerFooter
      ? drawerFooter.querySelector('.cart__ctas')
      : null;

    if (
      drawerFooter &&
      drawerCtas &&
      !drawerFooter.querySelector('[data-gcx-cart-discount]')
    ) {
      drawerFooter.insertBefore(buildCartDiscount(), drawerCtas);
    }
  }

  function resetCartPageScroll() {
    if (!document.body.classList.contains('page-cart')) return;

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    if (window.location.hash === '') {
      window.scrollTo(0, 0);
      window.requestAnimationFrame(function () {
        window.scrollTo(0, 0);
      });
    }
  }

  function handleStickyCartClick(event) {
    var stickyButton = event.target.closest('[data-gcx-mobile-add]');

    if (!stickyButton) return;

    var productSubmit = document.querySelector(
      'product-form .product-form__submit[name="add"]:not([disabled])'
    );

    if (!productSubmit) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    stickyButton.disabled = true;
    stickyButton.classList.remove('is-added');
    stickyButton.classList.add('is-loading');
    stickyButton.textContent = 'Adding...';

    productSubmit.click();

    var cartDrawer = document.querySelector('cart-drawer');
    var resetTimer = window.setTimeout(function () {
      stickyButton.disabled = false;
      stickyButton.classList.remove('is-loading');
      stickyButton.textContent = 'Add to Cart';
    }, 3500);

    if (!cartDrawer) return;

    var observer = new MutationObserver(function () {
      if (!cartDrawer.classList.contains('active')) return;

      window.clearTimeout(resetTimer);
      stickyButton.classList.remove('is-loading');
      stickyButton.classList.add('is-added');
      stickyButton.textContent = 'Added';
      insertCartDiscounts();
      observer.disconnect();

      window.setTimeout(function () {
        stickyButton.disabled = false;
        stickyButton.classList.remove('is-added');
        stickyButton.textContent = 'Add to Cart';
      }, 1800);
    });

    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function initGocoxConversionFixes() {
    insertPatentProof();
    designInStockShippingNote();
    insertCartDiscounts();
    resetCartPageScroll();
    syncCartDrawerOverlayState();
  }

  document.addEventListener('click', handleStickyCartClick, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGocoxConversionFixes, {
      once: true
    });
  } else {
    initGocoxConversionFixes();
  }

  document.addEventListener('shopify:section:load', initGocoxConversionFixes);
  document.addEventListener('change', function (event) {
    if (!event.target.closest('variant-selects, variant-radios')) return;

    window.setTimeout(designInStockShippingNote, 120);
  });

  var observedCartDrawer = document.querySelector('cart-drawer');

  if (observedCartDrawer) {
    var cartObserver = new MutationObserver(function () {
      insertCartDiscounts();
      syncCartDrawerOverlayState();
    });

    cartObserver.observe(observedCartDrawer, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });
  }
})();
